import { render, staticRenderFns } from "./createForm.vue?vue&type=template&id=3a0856ce&scoped=true&"
import script from "./createForm.vue?vue&type=script&lang=js&"
export * from "./createForm.vue?vue&type=script&lang=js&"
import style0 from "./createForm.vue?vue&type=style&index=0&id=3a0856ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0856ce",
  null
  
)

export default component.exports